import { styled } from '@mui/material'
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder'

export const BookmarkIcon = styled(BookmarkBorderIcon)`
  color: ${props => props.theme.palette.gray[50]};
  font-size: 25px;
`

export const Box = styled('div')`
  padding: ${props => props.padding || '0'};
`

export const Container = styled('div')`
  display: grid;
  grid-gap: 10px;
  padding: 1em 1em 0 1em;

  ${props => props.theme.breakpoints.up('sm')} {
    grid-template-columns: 1fr 1.3fr 1fr;
    padding: 2em 0 0;
  }
`

export const Content = styled('div')`
  display: grid;
  grid-template-columns: 35px 1fr;
`

export const Link = styled('a')`
  color: ${props => props.theme.palette.blue[50]};
  cursor: pointer;
  font-size: 12px;
  font-weight: normal;
  margin-left: 10px;
  text-align: center;
  text-decoration: none;

  ${props => props.theme.breakpoints.up('sm')} {
    text-align: left;
  }

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
  }
`

export const MoreInformation = styled('div')`
  display: inline;
`

export const Root = styled('div')`
  width: 100%;
`

export const Separator = styled('hr')`
  border: 0;
  border-top: 1px solid ${props => props.theme.palette.custom.gray[75.5]};
  box-sizing: content-box;
  height: 0;
  margin: 24px 0;
  overflow: visible;
`
